import { languageMenuStyles } from "@insite/content-library/Widgets/Common/LanguageMenu";
import { css } from "styled-components";

languageMenuStyles.languageSelect = {
    ...languageMenuStyles.languageSelect,
    cssOverrides: {
        formInputWrapper: css`
            width: 135px;
            #languageMenu {
                box-shadow: none;
            }
        `,
        inputSelect: css`
            border: none;
            text-transform: uppercase;
        `,
    },
};

languageMenuStyles.languageIcon = {
    ...languageMenuStyles.languageIcon,
    css: css`
        margin-right: 5px;
    `,
};
